export default (api) => {
  api.user = {
    public: {
    },
    admin: {
      ids: (params = {}) => api.request({
        url: `/api/admin/user/ids`,
        type: 'get',
        params,
      }),
      index: (params = null) => api.request({
        url: `/api/admin/user/index`,
        type: 'get',
        params,
      }),
      read: (id) => api.request({
        url: `/api/admin/user/${id}`,
        type: 'get',
      }),
      create: (params = {}) => api.request({
        url: `/api/admin/user`,
        type: 'post',
        params,
      }),
      updateAll: (id, params = {}) => api.request({
        url: `/api/admin/user/${id}/all`,
        type: 'put',
        params,
      }),
      update: (id, params = {}) => api.request({
        url: `/api/admin/user/${id}/update`,
        type: 'put',
        params,
      }),
      batch: (params) => api.request({
        url: `/api/admin/user/batch`,
        type: 'put',
        params,
      }),
      delete: (id) => api.request({
        url: `/api/admin/user/${id}`,
        type: 'delete',
      }),
      batchDelete: (params) => api.request({
        url: `/api/admin/user/batch`,
        type: 'delete',
        params,
      }),
      roles: () => api.request({
        url: `/api/admin/user/roles`,
        type: 'get',
      }),
      updateUsername: (id, params = {}) => api.request({
        url: `/api/admin/user/${id}/username`,
        type: 'put',
        params,
      }),
      updateEmail: (id, params = {}) => api.request({
        url: `/api/admin/user/${id}/email`,
        type: 'put',
        params,
      }),
      updatePassword: (id, params = {}) => api.request({
        url: `/api/admin/user/${id}/password`,
        type: 'put',
        params,
      }),
      checkPasswordRecord: () => api.request({
        url: `/api/admin/user/checkPasswordRecord`,
        type: 'get',
      }),
      passwordRecords: (id, params) => api.request({
        url: `/api/admin/user/${id}/passwordRecords`,
        type: 'get',
        params
      }),
      loginRecords: (id, params) => api.request({
        url: `/api/admin/user/${id}/loginRecords`,
        type: 'get',
        params
      }),
    },
  }

  api.userAccount = {
    admin: {
      readProfile: () => api.request({
        url: `/api/admin/account/profile`,
        type: 'get',
      }),
      updateProfile: (params) => api.request({
        url: `/api/admin/account/profile`,
        type: 'put',
        params,
      }),
      verifyIdentity: (params) => api.request({
        url: `/api/admin/account/verify-identity`,
        type: 'post',
        params,
      }),
      login: (params) => api.request({
        url: `/api/admin/account/login`,
        type: 'put',
        params,
      }),
      renewToken: () => api.request({
        url: `/api/admin/account/token`,
        type: 'put',
        ignore401Reject: true,
      }),
      emitLoginSuccessEvent: () => api.request({
        url: `/api/admin/account/emit-login-success-event`,
        type: 'post',
      }),
      createVerify: (params = {}) => api.request({
        url: `/api/admin/account/verify`,
        type: 'post',
        params,
      }),
      loginByVerifyCode: (params = {}) => api.request({
        url: `/api/admin/account/verify-code/login`,
        type: 'put',
        params,
      }),
      resetPassword: (params = {}) => api.request({
        url: `/api/admin/account/reset-password`,
        type: 'put',
        params,
      }),
      logoutDevice: (deviceId) => api.request({
        url: `/api/admin/account/device/${deviceId}`,
        type: 'delete',
      }),
      createEnduringToken: () => api.request({
        url: `/api/admin/account/enduring-token`,
        type: 'post',
      }),
      loginWithEnduringToken: (params) => api.request({
        url: `/api/admin/account/enduring-token/login`,
        type: 'put',
        params,
      }),
    },
  }

  api.userGroup = {
    public: {
    },
    admin: {
      index: (params = null) => api.request({
        url: `/api/admin/user-group/index`,
        type: 'get',
        params,
      }),
      read: (id) => api.request({
        url: `/api/admin/user-group/${id}`,
        type: 'get',
      }),
      create: (params = {}) => api.request({
        url: `/api/admin/user-group`,
        type: 'post',
        params,
      }),
      updateAll: (id, params = {}) => api.request({
        url: `/api/admin/user-group/${id}/all`,
        type: 'put',
        params,
      }),
      update: (id, params = {}) => api.request({
        url: `/api/admin/user-group/${id}/update`,
        type: 'put',
        params,
      }),
      batch: (params) => api.request({
        url: `/api/admin/user-group/batch`,
        type: 'put',
        params,
      }),
      delete: (id) => api.request({
        url: `/api/admin/user-group/${id}`,
        type: 'delete',
      }),
      batchDelete: (params) => api.request({
        url: `/api/admin/user-group/batch`,
        type: 'delete',
        params,
      }),
    },
  }

  api.operateRecord = {
    admin: {
      index: (params = null) => api.request({
        url: `/api/admin/operateRecords/index`,
        type: 'get',
        params,
      }),
      
    },
  }

  api.loginRecord = {
    admin: {
      index: (params = null) => api.request({
        url: `/api/admin/loginRecords/index`,
        type: 'get',
        params,
      }),
      
    },
  }

  api.resetPasswordRecords = {
    admin: {
      index: (params = null) => api.request({
        url: `/api/admin/resetPasswordRecords/index`,
        type: 'get',
        params,
      }),
      
    },
  }

}